<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>Video
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="articleEn">
      <div>
        <div class="PcDevice">
          <div class="contentBoxStatus">
            <p class="mb-2 text-center" style="font-size: 15px">
              Please upload the complete information for the following items to ensure the visitors understand your
              company, products, and services clearly
            </p>

            <div
              class="mb-4 border text-center py-2"
              style="font-size: 15px; margin-right: 17%; margin-left: 17%; border-radius: 30px"
            >
              <div class="d-flex justify-content-around">
                <a :href="`profile?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="BasicinformationStatus == 1" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">Information </span>
                  </div>
                </a>

                <a :href="`product?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="ProductStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span class="border-dark text-dark">Products </span>
                  </div>
                </a>

                <a :href="`news?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="PressReleaseStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">Press Release </span>
                  </div>
                </a>

                <a :href="`video?no=${RegNo}`">
                  <div class="d-flex align-items-center">
                    <span v-if="VideoStatus !== 0" class="complete mr-1"></span>
                    <span v-else class="uncomplete mr-1"></span>
                    <span style="color: black">Video </span>
                  </div>
                </a>

                <span v-if="showOnlineStatus">
                  <a :href="`onlineExpo?no=${RegNo}`">
                    <div class="d-flex align-items-center">
                      <span v-if="OnlineExpolayoutStatus == 1" class="complete mr-1"></span>
                      <span v-else class="uncomplete mr-1"></span>
                      <span style="color: black">Online Expo Settings </span>
                    </div>
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="MbDevice container contentBoxStatus">
          <div class="contentBoxStatus">
            <p class="mb-3 text-center" style="font-size: 12px">
              Please upload the complete information for the following items to ensure the visitors understand your
              company, products, and services clearly
            </p>

            <div class="mb-4 border text-center py-2" style="font-size: 12px; border-radius: 10px">
              <div class="d-flex justify-content-around">
                <div>
                  <a :href="`profile?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="BasicinformationStatus == 1" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <span style="color: black">Information </span>
                    </div>
                  </a>
                </div>
                <div>
                  <a :href="`product?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="ProductStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span class="border-dark text-dark">Products </span>
                      </div>
                    </div>
                  </a>
                </div>

                <div>
                  <a :href="`news?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="PressReleaseStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">Press Release </span>
                      </div>
                    </div>
                  </a>
                </div>

                <div>
                  <a :href="`video?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="VideoStatus !== 0" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">Video </span>
                      </div>
                    </div>
                  </a>
                </div>

                <div v-if="showOnlineStatus">
                  <a :href="`onlineExpo?no=${RegNo}`">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-md-6">
                        <span v-if="OnlineExpolayoutStatus == 1" class="complete"></span>
                        <span v-else class="uncomplete"></span>
                      </div>
                      <div class="col-md-6">
                        <span style="color: black">
                          <p>Online Expo</p>
                          <p>Settings</p>
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="contentBox">
          <h1>Video</h1>
          <p class="my-3">&nbsp;</p>

          <div class="alert text-dark alert-light mb-5" role="alert">
            <p>
              You have published <span class="red">{{ VideoPub }}</span> video(s), you can still create
              <span class="red">{{ VideoAvailable }}</span> video(s). Sort by last modified date.
            </p>
          </div>
          <div class="d-flex align-items-center my-2">
            <div class="PcDevice">
              <div class="btn btn-lg btn-primary mr-3 text-nowrap" @click.prevent="toEnVidoeAdd">Add Video</div>
            </div>
            <div class="MbDevice">
              <div class="btn btn-primary mr-2 text-nowrap" @click.prevent="toEnVidoeAdd">Add Video</div>
            </div>
            <p>
              Want to publish more videos? Please check<a :href="`upgrade?no=${RegNo}`" class="AddRegLink">
                Paid Services</a
              >.
            </p>
          </div>
          <p class="my-3">&nbsp;</p>

          <div class="PcDevice">
            <ul id="product" v-for="item in videoList">
              <li>
                <div class="row justify-content-between align-items-center mx-1">
                  <div class="col-md-7">
                    <div class="d-flex ml-3 align-items-center">
                      <div class="mt-4" v-if="item.videoLink">
                        <lite-youtube :videoid="`${item.videoLink}`" width="200px"> </lite-youtube>
                      </div>

                      <div class="mt-4" v-if="item.videoLink_Youku">
                        <iframe
                          width="320px"
                          height="180px"
                          :src="`https://player.youku.com/embed/${item.videoLink_Youku}`"
                          frameborder="0"
                        ></iframe>
                      </div>

                      <div class="ml-4">
                        <p class="formTitle mb-2">{{ item.eVideoTopic }}</p>
                        <p class="gray">
                          Display：
                          <span class="text-danger" v-if="item.archive == 1">Hidden</span>
                          <span class="text-success" v-else>Shown</span>
                        </p>

                        <p class="gray" v-if="item.archive == 0">
                          Website：
                          <i class="fas fa-eye mr-2"></i>
                          <a :href="item.eExhWebsiteVideoUrl" target="_blank">Link</a>
                        </p>

                        <p class="gray">Update：{{ item.UpdateTime }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 text-right mt-3 r-5">
                    <div class="btn btn-lg btn-primary text-nowrap" @click.prevent="editVideoEn(item.VideoID)">
                      Edit
                    </div>

                    <div
                      class="btn btn-lg btn-secondary text-nowrap ml-2 mr-5"
                      @click.prevent="deleteVideo(item.VideoID)"
                    >
                      Del
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>
          </div>

          <div class="MbDevice">
            <div class="col-lg-10 text-dark">
              <div class="row">
                <div class="col-sm-6 mb-2" v-for="(item, index) in videoList" :key="index">
                  <div class="card mt-4">
                    <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-if="item.videoLink">
                          <div class="mb-3">
                            <lite-youtube :videoid="`${item.videoLink}`"></lite-youtube>
                            <!-- <a :href="`https://www.youtube.com/embed/${item.videoLink}`"
                                                        frameborder="0" allow="autoplay; encrypted-media" data-fancybox
                                                        data-width="1280" data-height="720">
                                                        <img :src="`https://img.youtube.com/vi/${item.videoLink}/mqdefault.jpg`"
                                                            class="BannerHover img-fluid " width="300px" alt="" />
                                                    </a> -->
                          </div>
                        </li>
                        <li class="list-group-item" v-if="item.videoLink_Youku">
                          <div class="mb-3">
                            <iframe
                              width="100%"
                              height="100%"
                              :src="`https://player.youku.com/embed/${item.videoLink_Youku}`"
                              frameborder="0"
                            ></iframe>
                          </div>
                        </li>
                        <div class="mx-2 mt-2 mb-3">
                          <strong>{{ item.eVideoTopic }}</strong>
                          <p class="gray mt-1" v-if="item.archive == 0">
                            Website：
                            <i class="fas fa-eye mr-2"></i>
                            <a :href="item.eExhWebsiteVideoUrl" target="_blank">Link</a>
                          </p>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mx-2">
                          <div>
                            Display :
                            <span class="text-danger text-nowrap" v-if="item.archive === 1">Hidden</span>
                            <span v-else class="text-success text-nowrap">Shown</span>
                          </div>
                          <div class="d-flex justify-content-end">
                            <div class="btn btn-sm btn-primary" @click.prevent="editVideoEn(item.VideoID)">Edit</div>
                            <div
                              class="btn btn-sm btn-secondary btn-primary ml-2"
                              @click.prevent="deleteVideo(item.VideoID)"
                            >
                              Del
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: 'Video - ExhibitorServiceTW',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        videoList: [],
        videoID: '',
        videoData: [],

        videoType: 3,
        VideoTopic: '',
        eVideoTopic: '',
        videoLink: '',
        videoLink_Youku: '',
        VideoContent: '',
        videoArchive: '0',
        show: false,
        CSRF_Token: '',
        VideoAmount: 0,
        VideoPub: 0,
        lang: 'en',
        date: '',

        UploadvideoID: '',
        Serno: '',

        //判斷各頁狀態儀表版值
        OnlineExpolayoutStatus: '',
        PressReleaseStatus: '',
        VideoStatus: '',
        ProductStatus: '',
        BasicinformationStatus: '',

        //判斷儀表板是否有線上展
        HasOnlineExpo: '',
        openOnlineExpo: '',
        showOnlineStatus: false,

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },

    watch: {
      videoLink() {
        if (this.videoLink_Youku && this.videoLink) {
          this.videoLink_Youku = ''
        } else {
          let YtDelSpace = this.videoLink.trim()
          this.videoLink = YtDelSpace
        }
      },

      videoLink_Youku() {
        if (this.videoLink_Youku && this.videoLink) {
          this.videoLink = ''
        } else {
          let YkDelSpace = this.videoLink_Youku.trim()
          this.videoLink_Youku = YkDelSpace
        }
      },
    },

    methods: {
      toVideolink() {
        vm.closefancybox()
        parent.window.location = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${RegNo}`
      },

      toEnVideolink() {
        vm.closefancybox()
        parent.window.location = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${RegNo}`
      },

      deleteVideo(id) {
        const vm = this

        if (vm.lang == 'tw') {
          if (confirm('請確認要刪除此筆影音嗎？')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?VideoNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          } else {
            return false
          }
        } else {
          if (confirm('Delete this video?')) {
            const info = {
              CSRF: vm.CSRF_Token,
            }

            const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?VideoNo=${id}`

            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          } else {
            return false
          }
        }
      },
      updateVideo() {
        const vm = this
        const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        const info = {
          VideoTopic: vm.videoData.VideoTopic,
          eVideoTopic: vm.videoData.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoData.archive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.videoData.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.videoData.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功修改影音內容！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      updateEnVideo() {
        const vm = this
        const url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        const info = {
          // RegNo: vm.RegNo,
          VideoTopic: vm.videoData.VideoTopic,
          eVideoTopic: vm.videoData.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoData.archive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.videoData.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.videoData.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully changed video information! ')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      editVideo(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/videoEdit?no=${vm.RegNo}&id=${id}`
      },

      editVideoEn(id) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/videoEdit?no=${vm.RegNo}&id=${id}`
      },

      backVideoPage() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
        }
      },

      toVidoeAdd() {
        const vm = this
        if (vm.VideoAvailable > 0) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/videoAdd?no=${vm.RegNo}`
        } else {
          alert(`您已發佈 ${vm.VideoPub} 則參展商影音，如需發佈更多影音資訊，請至加值服務方案查看升級辦法。`)
        }
      },

      toEnVidoeAdd() {
        const vm = this
        if (vm.VideoAvailable > 0) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/videoAdd?no=${vm.RegNo}`
        } else {
          alert(`You have published ${vm.VideoPub} video(s). Want to publish more video? Please check Paid Services.`)
        }
      },

      AddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('輸入欄位不完整，請重新檢查！')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功新增影音！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      AddEnNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,

          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/video?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      TwCnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: vm.videoArchive,
          CSRF: vm.CSRF_Token,
        }

        // if (!vm.VideoTopic || !vm.videoLink) {
        //   alert('輸入欄位不完整，請重新檢查！')
        //   if (!vm.VideoTopic) {
        //     $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")
        //     $('#error2').html("<p class='errorTextArea'></p>")

        //     if (!vm.videoLink) {
        //       $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
        //     }
        //   } else {
        //     $('#error1').html("<span class='errorTextArea'></span>")
        //     $('#error2').html("<div class='errorTextArea'>請填寫此欄位</div>")
        //   }
        // } else {
        //   axios.post(url, info).then(function (response) {
        //     if (response.data.Code == 200) {
        //       alert('您已成功新增影音！')
        //       document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
        //     } else if (response.data.Code == 251 || response.data.Code == 500) {
        //       alert('系統忙碌，請稍後再試！')
        //       document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
        //     } else if (response.data.Code == 252) {
        //       document.location.href = `https://www.chanchao.com.tw/`
        //     }
        //   })
        // }

        if (!vm.VideoTopic) {
          alert('輸入欄位不完整，請重新檢查！')
          $('#error1').html("<span class='errorTextArea'>請填寫此欄位</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>請填寫此欄位</span>")
          }
        } else if (vm.VideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('您已成功新增影音！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      EnEnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      TwEnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      closefancybox() {
        parent.$.fancybox.close()
      },

      EnCnAddNewVideo() {
        const vm = this
        const url = '/apiExhibitors/ExhibitorVideo/'

        const info = {
          RegNo: vm.RegNo,
          VideoTopic: vm.VideoTopic,
          eVideoTopic: vm.eVideoTopic,
          videoLink: vm.videoLink,
          videoLink_Youku: vm.videoLink_Youku,
          Archived: 0,
          CSRF: vm.CSRF_Token,
          origin: 'ExpoVideo',
        }

        if (!vm.eVideoTopic) {
          alert('There are incomplete fields, please check again.')
          $('#error1').html("<span class='errorTextArea'>This field is required.</span>")

          if (!vm.videoLink && !vm.videoLink_Youku) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            $('#error2').empty("<span class='errorTextArea'>This field is required.</span>")
          }
        } else if (vm.eVideoTopic) {
          if (!vm.videoLink && !vm.videoLink_Youku) {
            alert('There are incomplete fields, please check again.')
            $('#error1').empty("<span class='errorTextArea'>This field is required.</span>")
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
          } else {
            axios.post(url, info).then(function (response) {
              if (response.data.Code == 200) {
                alert('Successfully published video!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/oversea_zhtw_onlineExpoVideoList?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                vm.closefancybox()
                parent.window.location.reload()
              } else if (response.data.Code == 252) {
                vm.closefancybox()
                parent.window.location.reload()
              }
            })
          }
        }
      },

      eSaveOnlineVideo() {
        const vm = this
        const url = '/apiExhibitors/EditOnlineExhibitionVideo/'

        const info = {
          RegNo: vm.RegNo,
          videoID: vm.UploadvideoID,
          CSRF: vm.CSRF_Token,
        }

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('System is busy, please try again later.')
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 252) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 253) {
            alert(' Please choose one video and click SAVE for your latest update')
            // vm.closefancybox()
            // parent.window.location.reload()
          }
        })
      },

      saveOnlineVideo() {
        const vm = this
        const url = '/apiExhibitors/EditOnlineExhibitionVideo/'

        const info = {
          RegNo: vm.RegNo,
          videoID: vm.UploadvideoID,
          CSRF: vm.CSRF_Token,
        }

        axios.post(url, info).then(function (response) {
          // console.log(response.data.Code)
          if (response.data.Code == 200) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 252) {
            vm.closefancybox()
            parent.window.location.reload()
          } else if (response.data.Code == 253) {
            alert('請先選擇攤位播放影片再按下儲存！')
            // vm.closefancybox()
            // parent.window.location.reload()
          }
        })
      },
    },

    computed: {
      VideoAvailable() {
        const vm = this
        return vm.VideoAmount - vm.VideoPub
      },
    },

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]
      vm.videoID = currentUrl.split('id=')[1]

      // console.log(vm.RegNo)

      //url取載入頁面參數

      if (vm.lang == 'tw') {
        var getHtmlurl = currentUrl.split('/')[4]
        var HtmlName = getHtmlurl.split('?')[0]
      } else {
        //url取英文載入頁面參數
        var getEnHtmlurl = currentUrl.split('/')[5]
        var HtmlEnName = getEnHtmlurl.split('?')[0]
      }

      //取得時間
      let theDate = new Date()
      vm.date = `${theDate.getFullYear()}/${theDate.getMonth() + 1}/${theDate.getDate()}`

      //影片額度
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response)

        vm.HasOnlineExpo = response.data.Data.Virtual

        vm.VideoAmount = response.data.Data.VideoAmount

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus
        vm.VideoStatus = response.data.Data.VideoStatus
        vm.ProductStatus = response.data.Data.ProductStatus
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus

        //取得是否開啟線上展權限
        axios
          .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`)
          .then((response) => {
            // console.log(response.data.Data)

            vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
            vm.ExhBegin = response.data.Data.ExhBegin
            vm.ExhEnd = response.data.Data.ExhEnd
            vm.ExhVenue = response.data.Data.ExhVenue
            vm.eExhVenue = response.data.Data.eExhVenue

            vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived

            if (vm.openOnlineExpo == 1 && vm.HasOnlineExpo == 1) {
              vm.showOnlineStatus = true
            } else {
              vm.showOnlineStatus = false
            }
          })
      })

      //取得線上展總資料
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/DisplayOnlineExpoControl/${vm.RegNo}`).then((response) => {
        if (response.data.Data) {
          vm.UploadvideoID = response.data.Data.VideoID
          vm.Serno = response.data.Data.Serno
        }
      })

      //判定當前網頁網址
      if (
        HtmlName == 'video' ||
        HtmlEnName == 'video' ||
        HtmlName == 'onlineExpoVideoList' ||
        HtmlName == 'onlineVideoAdd' ||
        HtmlName == 'oversea_onlineExpoVideoList' ||
        HtmlEnName == 'onlineExpoVideoList' ||
        HtmlEnName == 'onlineVideoAdd' ||
        HtmlName == 'oversea_zhtw_onlineExpoVideoList'
      ) {
        let url = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}?Page=1`
        axios.get(url).then(function (response) {
          if (response.data.Code == 200) {
            vm.videoList = response.data.Data
            vm.VideoPub = response.data.datatotal
            vm.show = true
          } else if (response.data.Code == 404) {
            vm.show = false
          }
        })
      } else if (HtmlName == 'videoEdit' || HtmlEnName == 'videoEdit') {
        let url2 = `/apiExhibitors/ExhibitorVideo/${vm.RegNo}/${vm.videoID}`
        axios
          .get(url2)
          .then(function (response) {
            // console.log(response.data.Data)

            if (response.data.Code == 200) {
              if (response.data.Data) {
                vm.videoData = response.data.Data
                vm.videoLink = response.data.Data.videoLink
                vm.videoLink_Youku = response.data.Data.videoLink_Youku

                if (response.data.Data.videoLink) {
                  vm.videoType = 3
                } else if (response.data.Data.videoLink_Youku) {
                  vm.videoType = 4
                }
              } else {
                alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
              }
            } else if (response.data.Code == 404) {
              vm.videoData = []
            }
          })
          .catch((err) => {
            alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/video?no=${vm.RegNo}`
          })
      }
    },
  }
</script>

<style lang="scss">
  .list-group-item {
    padding: 0.1rem 0.2rem;
  }

  .table th,
  .table td {
    text-align: center;
    vertical-align: middle !important;
  }

  @media screen and (min-width: 576px) {
    lite-youtube {
      width: 320px;
      height: 180px;
      cursor: pointer;
    }
  }

  .topUK {
    position: relative;
  }

  .insideUK {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(162, 166, 167, 0.411);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .uncomplete {
    background-image: url('../../../assets/images/tickGray.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }

  .complete {
    background-image: url('../../../assets/images/tick.svg');
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: auto 100%;
    padding-left: 20px;
  }
</style>
